var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSuccess = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.8678 9.24041C16.111 8.87154 16.0091 8.37536 15.6402 8.13218C15.2714 7.88899 14.7752 7.99088 14.532 8.35975L10.9239 13.8326L9.36567 12.2743C9.05325 11.9619 8.54673 11.9619 8.23431 12.2743C7.9219 12.5867 7.9219 13.0933 8.23431 13.4057L10.4862 15.6576C10.6562 15.8276 10.8936 15.9121 11.1328 15.8878C11.3719 15.8635 11.5875 15.7329 11.7198 15.5322L15.8678 9.24041Z",
  fill: "inherit"
})));
export default SvgSuccess;